/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl';
import { AsideMenuItem } from './AsideMenuItem';
import { useAuth } from '../../../../app/modules/auth';
import { Buffer } from 'buffer';
import { toAbsoluteUrl } from '../../../../_vtsl/helpers';
import Data from '../../../../app/utils/SetGetData';
import useState from 'react-usestateref';
import React, { useEffect } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { Link, useNavigate } from "react-router-dom";


export function AsideMenuMain() {
  const { currentUser, logout, setCurrentUser } = useAuth();
  const [pin, setPin] = useState();
  const [userType, setUserType] = useState();

  const [reseller, setReseller] = useState();
  const [showLogout, setShowLogout] = useState(false);
  const [logoutData, setLogoutData, logoutDataref] = useState();
  const [userResellerId, setUserResellerId, userResellerIdref] = useState();
  const [ResellerTenantName, setResellerTenantName, ResellerTenantNameref] = useState();
  const [ExtensionShowLogout, setExtensionShowLogout, ExtensionShowLogoutref] = useState();

  const navigate = useNavigate();




  const intl = useIntl();

  useEffect(() => {
    const b_token = localStorage.getItem('B_Token')
    const decodedToken = Buffer.from(b_token, "base64").toString()
    const pin = decodedToken.split(":")[1]
    setPin(pin)
    const userType = localStorage.getItem('user_type')
    setUserType(userType)
    const reseller = localStorage.getItem('is_reseller')
    setReseller(reseller)
    const showLogout = localStorage.getItem('ShowLogout') === 'true'; // Convert string to boolean
  
    setShowLogout(showLogout)
    const tenantInfoData = localStorage.getItem('tenantInfoData')
    setLogoutData(tenantInfoData)
    const userResellerId = localStorage.getItem('userResellerId')
    setUserResellerId(userResellerId)
   
    const ResellerTenantName = localStorage.getItem('ResellerTenantName')
    setResellerTenantName(ResellerTenantName)
    const ExtensionShowLogout = localStorage.getItem('ExtensionShowLogout')
    setExtensionShowLogout(ExtensionShowLogout)


  }, []);
  const lastActivity = localStorage.getItem('lastActivity');

  if (lastActivity) {
    const now = new Date().getTime();
    const lastActivityTime = parseInt(lastActivity, 10);
    const timeDiff = now - lastActivityTime;
    if (timeDiff > 12 * 60 * 60 * 1000) {
      localStorage.removeItem('lastActivity');
      logout()
    }
  }

  const logoutTenant = () => {
    localStorage.removeItem('CurrentTId')
    localStorage.removeItem('ExtensionShowLogout');
    localStorage.removeItem('ShowLogout');
    window.location.reload();

  }
  const logoutTen = () => {
    localStorage.clear(); // Removes all items from local storage
    window.location.href = '/auth/resellerLogin'; // Redirects to the auth/reseller page
  }

  const logoutTenantExtension = () => {
    // localStorage.removeItem('CurrentTId')
    localStorage.removeItem('ExtensionShowLogout');
    localStorage.removeItem('ExtensionPortalExtensionId');
    const userResellerId = localStorage.getItem('userResellerId')
    const OrignalB_Token = localStorage.getItem('OrignalB_Token')

    Data.setData('B_Token', OrignalB_Token);


    if (userResellerId != null) {
      Data.setData('ShowLogout', true);

      navigate('/userManagemnet')
      window.location.reload();
    }
    else {
      window.location.reload();
    }


    //  Data.setData('OrignalExtension', currentUser.extension);
    //     Data.setData('CurrentExtension', row.extension);
    //     Data.setData('Extensionfirstname', row.firstname);
    //     Data.setData('Extensionlastname', row.lastname);

    //     Data.setData('ExtensionShowLogout', true);
    //     const updatedUserInfo = { ...currentUser };
    //     updatedUserInfo.extension = row.extension
    //     updatedUserInfo.firstname = row.firstname
    //     updatedUserInfo.lastname = row.lastname
    //     console.log('updatedUserInfo', updatedUserInfo)
    //     setCurrentUser(updatedUserInfo);
  }
  const phonePage = () => {
    let tows = "tows.vtsl.net"
    if (currentUser.tenant_id.startsWith("2029")) {
      tows = "lab1tows.vtsl.net"
    }
    window.open(`https://${tows}/webadmin/en/user/jsp/ProcessBasicLogin.jsp?tenantWebName=${currentUser.tenant_web_name}&UserID=${currentUser.extension}&Password=${pin}&Target=basic/admin/Search.do?area=searchitem.keyprofile.description`, '_blank', 'noreferrer');
  }
  const MyphonePage = () => {
    let tows = "tows.vtsl.net"
    if (currentUser.tenant_id.startsWith("2029")) {
      tows = "lab1tows.vtsl.net"
    }
    window.open(`https://${tows}/webadmin/en/user/jsp/ProcessBasicLogin.jsp?tenantWebName=${currentUser.tenant_web_name}&UserID=${currentUser.extension}&Password=${pin}&Target=basic/MyPhone.do`, '_blank', 'noreferrer');
  }
  const MyDashboards = () => {

    window.open('/dashboards');
  }
  const CallMonitoring = () => {

    window.open('/callMonitoring');
  }
  const [recordingStatus, setRecordingStatus] = useState("error"); // "disabled", "enabled", "error"

  // API call to view the current call status
  const viewCallStatus = async () => {
    const actionId = uuidv4(); // Generate a unique action_id
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_URL}/callRecActions`,
        {
          user: `${currentUser.extension}@${currentUser.tenant_id}`,
          tenant: currentUser.tenant_id,
          action: "viewCallStatus",
          action_id: actionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // Map API response to UI states
      if (response.data.result === "success") {
        if (response.data.recording_status === "Started") {
          setRecordingStatus("enabled"); // Red Circle
        } else {
          setRecordingStatus("disabled"); // Green Circle
        }
      } else {
        setRecordingStatus("error"); // Gray Circle
      }
    } catch (error) {
      console.error("Error viewing call status:", error);
      setRecordingStatus("error");
    }
  };

  // API call to start recording
  const startRecording = async () => {
    const actionId = uuidv4(); // Generate a unique action_id
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_URL}/callRecActions`
        ,
        {
          user: `${currentUser.extension}@${currentUser.tenant_id}`,
          tenant: currentUser.tenant_id,
          action: "startRecording",
          action_id: actionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // Update state based on API response
      if (response.data.result === "success" && response.data.recording_status === "Started") {
        setRecordingStatus("enabled"); // Red Circle
      } else {
        setRecordingStatus("error"); // Gray Circle
      }
    } catch (error) {
      console.error("Error starting recording:", error);
      setRecordingStatus("error");
    }
  };

  // API call to stop recording
  const stopRecording = async () => {
    const actionId = uuidv4(); // Generate a unique action_id
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_URL}/callRecActions`,
        {
          user: `${currentUser.extension}@${currentUser.tenant_id}`,
          tenant: currentUser.tenant_id,
          action: "stopRecording",
          action_id: actionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // Update state based on API response
      if (response.data.result === "success" && response.data.recording_status === "Stopped") {
        setRecordingStatus("disabled"); // Green Circle
      } else {
        setRecordingStatus("error"); // Gray Circle
      }
    } catch (error) {
      console.error("Error stopping recording:", error);
      setRecordingStatus("error");
    }
  };

  // Handle dot click (toggle recording status)
  const handleDotClick = async () => {
    if (recordingStatus === "enabled") {
      await stopRecording();
    } else if (recordingStatus === "disabled") {
      await startRecording();
    }
  };


  useEffect(() => {
    // Function to call viewCallStatus every 3 seconds
    const intervalId = setInterval(() => {
      viewCallStatus();
    }, 3000); // 3000ms = 3 seconds

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  return (<>
    <div className='menu-item'>
      <a href='#' className='mb-12'>
        <img alt='Logo' src={toAbsoluteUrl('/media/logos/vtsl-logo.png')} className='theme-dark-show h-45px' />
        <img alt='Logo' src={toAbsoluteUrl('/media/logos/vtsl_logo_black.png')} className='theme-light-show h-45px'></img>
      </a>
      {!showLogout || showLogout === 'false' ? <div className='menu-content pt-8 pb-2'>
        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>My Settings</span>
      </div> : null}
    </div>


    {!showLogout || showLogout === 'false' ?
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "12px 16px",
          backgroundColor: "#2C2C2C", // Adjusted background color for better contrast
          borderRadius: "8px",
          width: "fit-content", // Ensures the container fits the content dynamically
          margin: "10px 0", // Adds spacing around the component
          cursor: 'pointer'

        }}

        onClick={handleDotClick}
      >
        {/* Status Indicator */}
        <div
          style={{
            width: 20, // Increased size slightly for better visibility
            height: 20,
            backgroundColor:
              recordingStatus === "enabled"
                ? "red"
                : recordingStatus === "error"
                  ? "gray"
                  : "green",
            borderRadius: "50%",
            marginRight: "10px", // Spacing between the circle and the text
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.5)", // Adds subtle shadow for depth
          }}
        >

        </div>

        {/* Status Text */}
        <div
          style={{
            display: "inline-block", // Makes the button size minimal
            backgroundColor: "#333333", // Button background color
            color: "#FFFFFF", // Text color
            padding: "2px 2px", // Reduced padding for compactness
            borderRadius: "8px", // Rounded corners
            fontSize: "14px", // Smaller font size for the main text
            fontWeight: "500", // Medium weight for better emphasis
            cursor: "pointer",
            textAlign: "center",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", // Subtle shadow for a modern look
          }}
        >
          {recordingStatus === "enabled" ? (
            <>
              Recording in progress
              <div
                style={{
                  fontSize: "12px", // Smaller font for secondary text
                  fontWeight: "400", // Normal weight

                }}
              >
                (click to pause recording)
              </div>
            </>
          ) : recordingStatus === "error" ? (
            <>
              Not Recording
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "400",

                }}
              >

              </div>
            </>
          ) : (
            <>
              Recording paused
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "400",

                }}
              >
                (Click to resume recording)
              </div>
            </>
          )}
        </div>
      </div> : null}



    {/* {currentUser.user_type!=="User"?
     <div>
      <AsideMenuItem
        to='tenant-management/tenants'
        icon='/media/icons/duotune/arrows/arr001.svg'
        title='Tenant Management'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='user-management/users'
        icon='/media/icons/duotune/arrows/arr001.svg'
        title='User Management'
        fontIcon='bi-layers'
      />
      </div>:
      
      <div>
      <AsideMenuItem
        to='profile'
        icon='/media/icons/duotune/arrows/arr001.svg'
        title='My Profile'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='call-control'
        icon='/media/icons/duotune/arrows/arr001.svg'
        title='Call Control'
        fontIcon='bi-layers'
      />
      
      <AsideMenuItem
        to='voice-mail'
        icon='/media/icons/duotune/arrows/arr001.svg'
        title='Voice Mail'
        fontIcon='bi-layers'
      />
      </div>
      } */}
    <div>
      {!showLogout || showLogout === 'false' ? <div>
        <AsideMenuItem
          to='profile'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Profile'
          fontIcon='bi-layers'
        />
        <AsideMenuItem
          to='cdrs-user'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Call History'
          fontIcon='bi-layers'
        />

        <AsideMenuItem
          to='call-control'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Call Control'
          fontIcon='bi-layers'
        />
        <AsideMenuItem
          to='call-groups'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Call Groups'
          fontIcon='bi-layers'
        />
        <div onClick={() => { MyphonePage() }}>
          <AsideMenuItem
            to=''
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='My Phone'
            fontIcon='bi-layers'
          />
        </div>

        <AsideMenuItem
          to='voice-mail'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Voice Mail'
          fontIcon='bi-layers'
        />
        <AsideMenuItem
          to='Schedules'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Schedule'
          fontIcon='bi-layers'
        />
        <AsideMenuItem
          to='blocknumbers'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='My Blocked Numbers'
          fontIcon='bi-layers'
        />
        <AsideMenuItem
          to='directory'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='Directory'
          fontIcon='bi-layers'
        />




      </div> : null}

      {userResellerId != null ? <div className='menu-content pt-8 '>
        <span className='menu-section  text-uppercase fs-8 ls-1'>-- Logged In As {ResellerTenantName} -- </span>
      </div> : null}

      {/* //////DASHBAORDS START///// */}
      {/* Services: show for normal tenant sessions and when logged in as another extension (reseller / user management). */}
      <div>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Services</span>
        </div>
        <div onClick={() => { MyDashboards() }} >


          <AsideMenuItem
            // to='dashboards'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Dashboard'
            fontIcon='bi-layers'
          />
          {/* //////DASHBAORDS END///// */}

        </div>
        <AsideMenuItem
          to='cdrsTenant'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='Call History'
          fontIcon='bi-layers'
        />
        <div onClick={() => { CallMonitoring() }} >
          <AsideMenuItem
            // to='callMonitoring2'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Call listening'
            fontIcon='bi-layers'
          />
        </div>
        <AsideMenuItem
          to='reporting'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='Call Reporting'
          fontIcon='bi-layers'
        />
        <div style={{ marginLeft: 40 }}>
          <AsideMenuItem
            to='business-groups'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Reporting Groups'
            fontIcon='bi-layers'
          />
        </div>
        <AsideMenuItem
          to='scheduling'
          icon='/media/icons/duotune/arrows/arr001.svg'
          title='Scheduled Call Reports'
          fontIcon='bi-layers'
        />
      </div>

      {/* Tenant settings: not shown while impersonating an extension from user management (ExtensionShowLogout). */}
      {!ExtensionShowLogoutref.current && userType != 'User' ? <div>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Tenant Settings</span>
          </div>
          {/* {userType != 'User - Manager' ? <div>
          {!showLogout ? <div>
            {reseller ?
              <AsideMenuItem
                to='tenantManagement'
                icon='/media/icons/duotune/arrows/arr001.svg'
                title='Tenant Management'
                fontIcon='bi-layers'
              /> : null}
          </div> : null}
        </div> : null} */}

          {userResellerId != null ? <AsideMenuItem
            to='tenantManagement'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Tenant Management'
            fontIcon='bi-layers'
          /> : null}
          <AsideMenuItem
            to='licensing'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Licensing'
            fontIcon='bi-layers'
          />
          <AsideMenuItem
            to='salesforce'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Salesforce'
            fontIcon='bi-layers'
          />


          {/* <AsideMenuItem
            // to='callMonitoring'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='Call Monitoring'
            fontIcon='bi-layers'
          /> */}


          <AsideMenuItem
            to='userManagemnet'
            icon='/media/icons/duotune/arrows/arr001.svg'
            title='User Management'
            fontIcon='bi-layers'
          />

          {!showLogout || showLogout === 'false' && userType === 'Admin' || userType === 'Admin - Manager' ? <div>

            <div onClick={() => phonePage()} >
              <AsideMenuItem
                to=''
                icon='/media/icons/duotune/arrows/arr001.svg'
                title='Phone Key Profiles'
                fontIcon='bi-layers'
              />
            </div>
          </div> : null}
          {userType != 'User - Manager' ? <div>
            <div style={{ marginLeft: 40 }}>
              <AsideMenuItem
                to='userprofiles'
                icon='/media/icons/duotune/arrows/arr001.svg'
                title='User Profiles'
                fontIcon='bi-layers'
              />

              <AsideMenuItem
                to='call-permission-profile'
                icon='/media/icons/duotune/arrows/arr001.svg'
                title='Call Permission Profile'
                fontIcon='bi-layers'


              />
              <AsideMenuItem
                to='monitor-groups'
                icon='/media/icons/duotune/arrows/arr001.svg'
                title='Extension Monitoring'
                fontIcon='bi-layers'

              />

            </div>


            <AsideMenuItem
              to='incomingcallroute'
              icon='/media/icons/duotune/arrows/arr001.svg'
              title='Incoming Call Routing'
              fontIcon='bi-layers'
            />
            <AsideMenuItem
              to='scheduledivets'
              icon='/media/icons/duotune/arrows/arr001.svg'
              title='Scheduled Diverts'
              fontIcon='bi-layers'
            />
            <AsideMenuItem
              to='calling-groups'
              icon='/media/icons/duotune/arrows/arr001.svg'
              title='Call Groups'
              fontIcon='bi-layers'

            />


          </div> : null}


          {userType != 'User - Manager' ? <div>
            <AsideMenuItem
              to='queue-groups'
              icon='/media/icons/duotune/arrows/arr001.svg'
              title='Queue Groups'
              fontIcon='bi-layers'
            />
            <AsideMenuItem
              to='auto-attendants'
              icon='/media/icons/duotune/arrows/arr001.svg'
              title='Auto Attendant/IVR'
              fontIcon='bi-layers'
            />
            <AsideMenuItem
              to='business-hours'
              icon='/media/icons/duotune/arrows/arr001.svg'
              title='Business Hours'
              fontIcon='bi-layers'
            />



          </div> : null}


        </div> : null}
      {ExtensionShowLogout ? <div onClick={logoutTenantExtension} className='menu-item d-flex justify-content-center mt-6'>
        <a href='#' className='menu-title' style={{ color: 'darkred' }}>Sign Out User</a>
      </div> : null
      }
      {showLogout && logoutDataref.current === null ? <div onClick={logoutTenant} className='menu-item d-flex justify-content-center mt-6'>
        <a href='#' className='menu-title' style={{ color: 'darkred' }}>Sign Out </a>
      </div> : null
      }
      {userResellerId === null ? <div onClick={logout} className='menu-item d-flex justify-content-center mt-6'>
        <a href='#' className='menu-title' style={{ color: 'darkred' }}>Sign Out</a>
      </div> : <div onClick={logoutTen} className='menu-item d-flex justify-content-center mt-6'>
        <a href='#' className='menu-title' style={{ color: 'darkred' }}>Sign Out </a>
      </div>}

    </div>

    {/* <AsideMenuItemWithSub to='/user-management' title='Users Management' fontIcon='bi-archive' icon='/media/icons/duotune/arrows/arr001.svg'>
          <AsideMenuItem to='/user-management/users' title='Users' hasBullet={true}/>
          <AsideMenuItem to='/user-management/permissions' title='Permissions' hasBullet={true}/>
      </AsideMenuItemWithSub> */}
  </>);
}
